import { useConfig } from '@@/common/services/useConfig';

import Logo, { TLogo } from './Logo';

export default function PaymentFormForTenant(
  props: Omit<TLogo, 'logos' | 'redirectUrls' | 'tenantDisplayName'>
) {
  const {
    config: { logos, redirectUrls, tenantDisplayName },
  } = useConfig();

  return (
    <Logo
      {...props}
      logos={logos}
      redirectUrls={redirectUrls}
      tenantDisplayName={tenantDisplayName}
    />
  );
}
export * from './Logo';
